module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/ashou3-d06d365feb88a04a4728a19b7f8ba971.jpg";